export function shouldShowClubLandSetup({ isPresident, tractCount, setupPath }) {
  return Boolean(isPresident) && Number(tractCount || 0) === 0 && !setupPath;
}

export function clubLandSetupPaths() {
  return [
    { id: 'draw', label: 'Draw boundary' },
    { id: 'parcels', label: 'Select parcels' },
  ];
}
